import React, { useContext, useEffect, useState } from 'react'
import { ButtonHeading, DriverDetailsTab, DriverTripTab } from 'components';
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';
import Ledger from '../Ledger';
import { UserContext } from 'context';
import { useLocation, useNavigate } from 'react-router-dom';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { AdjustBalanceModal } from 'modals';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const DriverDetails = () => {

    const query = useQuery();
    const navigate = useNavigate();
    const location = useLocation();

    // Query params
    const tabQuery = +query.get('tab');

    const { data } = location.state || {};
    const [activeTab, setActiveTab] = useState(data?.type); // data?.type

    useDocumentTitle("Driver Details| T360");
    const { isDriverName } = useContext(UserContext)
    const [openLedgerModal, setOpenLedgerModal] = useState(false);
    const [refreshLedger, setRefreshLedger] = useState(false);
    const [ledgerDetails, setLedgerDetails] = useState({});

    const handleActiveTabs = (e) => {
        setActiveTab(e);

        const params = new URLSearchParams(location.search);
        params.set('tab', e);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const tabProps = {
        tabList: data?.driver == "own" ? constant.driverDetailsTabs : constant.driverDetailsTabsForMarket,
        callBackTab: (e) => handleActiveTabs(e),
        activeTab: activeTab
    }

    const calback = () => {
        setOpenLedgerModal(false)
        setRefreshLedger(prev => !prev);
    }

    let LedgerAdjustModalProps = {
        isOpen: openLedgerModal,
        closeModal: (e) => setOpenLedgerModal(false),
        modalMainClass: "_dashCommon_Modal _prtThemeModal _smModal",
        footerPart: false,
        approvalBtn: true,
        approvalBtnTxt: 'Send for Approval',
        modalTitle: "Adjust Balance",
        submitTitle: "Adjust Balance",
        detailsData: ledgerDetails,
        venderType: "Driver",
        calback: calback
    }

    return (
        <div className=''>
            <ButtonHeading
                title={isDriverName ? isDriverName : (data?.name ? data?.name : 'Loading...')}
                buttonTitle="Back"
                isBackButton={true}
                onClickBackButton={() => navigate(-1)}
                ledgerButtonTitle={activeTab == 2 ? "Adjust Balance" : ""}
                ledgerOnClick={() => setOpenLedgerModal(true)}
            />

            <div className='addPr_flBx'>
                <Tab {...tabProps} />
                {activeTab == 1 && (
                    <DriverDetailsTab />
                )}
                {(activeTab == 2) && (
                    <Ledger type={3} refresh={refreshLedger} setLedgerDetails={setLedgerDetails} />
                )}
            </div>
            {openLedgerModal && <AdjustBalanceModal {...LedgerAdjustModalProps} />}
        </div>
    )
}

export default DriverDetails;